import { userActionTypes as types } from 'src/redux/actions/userActions';

const initialState = {
  loading: false,
  error: null,
  users: {},
};

export default function userReducer(state = initialState, { type, data, error }) {
  switch (type) {
    case types.FETCH_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case types.FETCH_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        users: data
      }
    case types.FETCH_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error
      }
    default:
      return state;
  }
}
